/**
 * Created by chenmf on 2017/7/6.
 */
export const SET_SELLER = 'SET_SELLER'
export const SET_GOODS = 'SET_GOODS'
export const ADD_TO_CART = 'ADD_TO_CART'
export const REMOVE_FROM_CART = 'REMOVE_FROM_CART'
export const CLEAR_CART = 'CLEAR_CART'



// WEBPACK FOOTER //
// ./src/store/mutation_types.js